import * as h from '../helpers/helpers';
import { GetSalesCompOutbuildingList } from './outbuildingFunctions';


export function GetSalesCompGeneralInformation() {
	let list = [];
	let comps = global.ptr.compList;
	list.push(GetDataSources(comps));
	list.push(GetProximityToSubject(comps));
	list.push(GetListPrice());
	list.push(GetListingStatus());
	list.push(GetContractPrice());
	list.push(GetSalePrice(comps));
	list.push(GetTransferTerms());
	list.push(GetFinancingType());
	list.push(GetSalesConcessions());
	list.push(GetContractDate());
	list.push(GetSaleDate(comps));
	list.push(GetDaysOnMarket());
	list.push(GetSaleToListRatio());
	list.push(GetAttachedDetached());
	list.push(GetPropertyRightsAppraised());
	list.push(GetAnnualGroundRent());
	list.push(GetNativeAmericanLands());
	list.push(GetAllRightsIncluded());
	list.push(GetRightsNotIncluded());
	list.push(GetSameBuilder());
	//console.log("SC", list);
	return list;
}

export function GetSalesCompProjectInformation() {
	let list = [];
	list.push(GetProjectNameAndSame());
	list.push(GetProjectMonthlyFee());
	list.push(GetProjectCommonAmenities());
	list.push(GetProjectSpecialAssessments());

	return list;
}

export function GetSalesCompSite() {
	let list = [];
	list.push(GetSiteOwnedInCommon());
	list.push(GetSiteSize());
	list.push(GetSiteNeighborhoodName());
	list.push(GetSiteZoningCompliance());
	list.push(GetSiteHazardZone());
	list.push(GetSitePrimaryAccess());
	list.push(GetSiteStreetTypeSurface());
	list.push(GetSitePropertyRestriction());
	list.push(GetSiteEasement());
	list.push(GetSiteTopography());
	list.push(GetSiteDrainage());
	list.push(GetSiteCharacteristics());
	list.push(GetSiteInfluenceLocation());
	list.push(GetSiteApparentEnvironmentalConditions());
	list.push(GetSiteViewRange());

	return list;
}

export function GetSalesCompWaterFrontage() {
	let list = [];
	list.push(GetWaterFrontage());
	list.push(GetWaterFrontagePermanentWaterfrontFeature());
	list.push(GetWaterFrontageRightToBuild());
	list.push(GetWaterFrontageTotalLinearMeasurement());

	return list;
}

export function GetSalesCompDwellings() {
	let list = [];
	list.push(GetDwellingsYearBuilt());
	list.push(GetDwellingsStructureDesign());
	list.push(GetDwellingsGrossBuildingFinishedArea());
	list.push(GetDwellingsNoncontinuousFinishedArea());
	list.push(GetDwellingsTownhouseEndUnit());
	list.push(GetDwellingsTownhouseBackToBack());
	list.push(GetDwellingsTownhouseLocation());
	list.push(GetDwellingsConstructionMethod());
	list.push(GetDwellingsManufacturedHomeWidth());
	list.push(GetDwellingsDwellingStyle());
	list.push(GetDwellingsTotalDwellingVolume());
	list.push(GetDwellingsWindowSurfaceArea());
	list.push(GetDwellingsFunctionalIssues());
	list.push(GetDwellingsDisasterMitigation());
	list.push(GetDwellingsHeating());
	list.push(GetDwellingsCooling());

	return list;
}

export function GetSalesCompEnergyEfficientAndGreenFeatures() {
	let list = [];
	list.push(GetEnergyRenewableEnergyComponent());
	list.push(GetEnergyBuildingCertification());
	list.push(GetEnergyEfficiencyRating());
	
	return list;
}

export function GetSalesCompUnits() {
	let list = [];
	//let pus = global.ptr.subProp.GetNonADUUnits();
	let pus = global.ptr.subProp.GetAllUnits();
	if (pus.length > 1) {
		for (let pu of pus) {
			let rels = global.ptr.relationships.GetRelationshipsTo("PROPERTY_UNIT_IsComparableFor_PROPERTY_UNIT", pu.label);
			let cpu = [];
			global.ptr.compList.forEach(cp => {
				let u = cp.GetUnitByLabels(rels);
				cpu.push(u);
			})

			let sp = GetSalesCompUnit(pu, cpu, true);
			list.push(sp);
		}
	} else {
		let cpu = [];
		global.ptr.compList.forEach(cp => {
			let u = cp.improvements.improvementList[0].propertyUnits[0];
			cpu.push(u);
		})

		let sp = GetSalesCompUnit(pus[0], cpu, false);
		list.push(sp);
	}
	return list;
}

export function GetSalesCompUnit(pu, cpu, includeIds) {
	let list = [];
	if (includeIds ) list.push(GetUnitsIDs(pu, cpu));
	list.push(GetUnitsLocationOfADU(pu, cpu));
	list.push(GetUnitsFloorNumber(pu, cpu));
	list.push(GetUnitsCornerUnit(pu, cpu));
	list.push(GetUnitsLevelsInUnit(pu, cpu));
	list.push(GetUnitsBedrooms(pu, cpu));
	list.push(GetUnitsBathsFullHalf(pu, cpu));
	list.push(GetUnitsFinishedAreaAboveGrade(pu, cpu));
	list.push(GetUnitsFinishedAreaAboveGradeNonstandard(pu, cpu));
	list.push(GetUnitsUnfinishedAreaAboveGrade(pu, cpu));
	list.push(GetUnitsFinishedAreaBelowGrade(pu, cpu));
	list.push(GetUnitsFinishedAreaBelowGradeNonstandard(pu, cpu));
	list.push(GetUnitsUnfinishedAreaBelowGrade(pu, cpu));
	list.push(GetUnitsFeaturesForIndividualsWithDisabilities(pu, cpu));

	return list;
}

export function GetSalesCompQCExteriorQC() {
	let list = [];
	let sdl = global.ptr.subDwellingList;
	let includeIds = sdl.length > 1 ? true : false;
	includeIds |= global.ptr.subDetail.homeownerResponsibleForExteriorMaintenanceIndicator;
	let inum = 0;
	sdl.forEach(sd => {
		let cl = [];
		global.ptr.compList.forEach(cp => {
			let imps = cp.improvements.GetImprovementsByType("Dwelling");
			if (inum < imps.length)
				cl.push(imps[inum]);
			else
				cl.push(null);
		});
		++inum;

		let sp = GetExteriorQC(sd, cl, includeIds);
		list.push(sp);

	})

	return list;
}

export function GetExteriorQC(sub, comps, includeIds) {
	let list = [];
	if (includeIds) list.push(GetQCExteriorStructureID(sub, comps));
	list.push(GetQCExteriorQuality(sub, comps));
	list.push(GetQCExteriorQualityExteriorWallsAndTrim(sub, comps));
	list.push(GetQCExteriorQualityFoundation(sub, comps));
	list.push(GetQCExteriorQualityRoof(sub, comps));
	list.push(GetQCExteriorQualityWindows(sub, comps));
	list.push(GetQCExteriorCondition(sub, comps));
	list.push(GetQCExteriorConditionExteriorWallsAndTrim(sub, comps));
	list.push(GetQCExteriorConditionFoundation(sub, comps));
	list.push(GetQCExteriorConditionRoof(sub, comps));
	list.push(GetQCExteriorConditionWindows(sub, comps));

	return list;
}

export function GetSalesCompQCInteriorQC() {
	let list = [];
	let pus = global.ptr.subProp.GetNonADUUnits();
	if (pus.length > 1) {
		for (let pu of pus) {
			let rels = global.ptr.relationships.GetRelationshipsTo("PROPERTY_UNIT_IsComparableFor_PROPERTY_UNIT", pu.label);
			let cpu = [];
			global.ptr.compList.forEach(cp => {
				let u = cp.GetUnitByLabels(rels);
				cpu.push(u);
			})

			let sp = GetQCInteriorQC(pu, cpu, true);
			list.push(sp);
		}
	} else {
		let cpu = [];
		global.ptr.compList.forEach(cp => {
			let u = cp.improvements.improvementList[0].propertyUnits[0];
			cpu.push(u);
		})

		let sp = GetQCInteriorQC(pus[0], cpu, false);
		list.push(sp);
	}

	return list;

}

export function GetQCInteriorQC(pu, cpu, includeIds) {
	let list = [];
	if (includeIds) list.push(GetQCInteriorStructureID(pu, cpu));
	list.push(GetQCInteriorQuality(pu, cpu));
	list.push(GetQCInteriorQualityKitchen(pu, cpu));
	list.push(GetQCInteriorQualityOverallBathrooms(pu, cpu));
	list.push(GetQCInteriorQualityOverallFlooring(pu, cpu));
	list.push(GetQCInteriorQualityWallsAndCeiling(pu, cpu));
	list.push(GetQCInteriorCondition(pu, cpu));
	list.push(GetQCInteriorConditionKitchen(pu, cpu));
	list.push(GetQCInteriorConditionOverallBathrooms(pu, cpu));
	list.push(GetQCInteriorConditionOverallFlooring(pu, cpu));
	list.push(GetQCInteriorConditionWallsAndCeiling(pu, cpu));
		
	return list;
}

export function GetSalesCompQCADUInteriors() {
	let list = [];
	let pus = global.ptr.subProp.GetADUUnits();
	for (let pu of pus) {
		let rels = global.ptr.relationships.GetRelationshipsTo("PROPERTY_UNIT_IsComparableFor_PROPERTY_UNIT", pu.label);
		let cpu = [];
		global.ptr.compList.forEach(cp => {
			let u = cp.GetUnitByLabels(rels);
			cpu.push(u);
		})

		let sp = GetSalesCompQCADUInterior(pu, cpu);
		list.push(sp);
	}
	return list;
}

function GetSalesCompQCADUInterior(pu, cpu) {
	let list = [];
	list.push(GetQCADUInteriorLocationOfADU(pu, cpu));
	list.push(GetQCADUInteriorQuality(pu, cpu));
	list.push(GetQCADUInteriorQualityKitchen(pu, cpu));
	list.push(GetQCADUInteriorQualityOverallBathrooms(pu, cpu));
	list.push(GetQCADUInteriorQualityOverallFlooring(pu, cpu));
	list.push(GetQCADUInteriorQualityWallsAndCeiling(pu, cpu));
	list.push(GetQCADUInteriorCondition(pu, cpu));
	list.push(GetQCADUInteriorConditionKitchen(pu, cpu));
	list.push(GetQCADUInteriorConditionOverallBathrooms(pu, cpu));
	list.push(GetQCADUInteriorConditionOverallFlooring(pu, cpu));
	list.push(GetQCADUInteriorConditionWallsAndCeiling(pu, cpu));

	return list;
}

export function GetSalesCompOverallQualityAndCondition() {
	let list = [];
	list.push(GetOverallQuality());
	list.push(GetOverallCondition());

	return list;
}

export function GetSalesCompPropertyAmenities() {
	let list = [];
	list.push(GetPropertyAmenitiesOutdoorAccessories());
	list.push(GetPropertyAmenitiesOutdoorLiving());
	list.push(GetPropertyAmenitiesWaterFeatures());
	list.push(GetPropertyAmenitiesWholeHome());
	list.push(GetPropertyAmenitiesMiscellaneous());

	return list;
}

export function GetSalesCompVehicleStorage() {
	let list = [];
	list.push(GetVehicleStorage());

	return list;
}

export function GetSalesCompOutbuildings() {
	let list = GetSalesCompOutbuildingList();
	return list;
}

export function GetSalesCompSummary() {
	let list = [];
	let comps = global.ptr.compList;
	list.push(GetSalesSummaryListPrice());
	list.push(GetSalesSummaryContractPrice());
	list.push(GetSalesSummarySalePrice(comps));
	list.push(GetSalesSummaryNetAdjustmentTotal());
	list.push(GetSalesSummaryAdjustedPricePerUnit());
	list.push(GetSalesSummaryAdjustedPricePerBedroom());
	list.push(GetSalesSummaryPricePerGrossBuildingFinishedArea());
	list.push(GetSalesSummaryPricePerFinishedAreaAboveGrade());
	list.push(GetSalesSummaryAdjustedPrice());
	list.push(GetSalesSummaryComparableWeight(comps));

	return list;
}

export function GetSalesCompSummaryIndicatedValue() {
	let list = [];
	//list.push(Get());

	return list;
}







/*******************************************************************************/
// 
//  General Information
// 
/*******************************************************************************/

export function GetCompAddresses() {
	let list = [];
	list.push("Property Address");
	list.push(global.ptr.subProp.address.GetFullAddress());

	global.ptr.compList.forEach(cp => {
		list.push(cp.address.GetFullAddress());
	});

	return list;
}

export function GetCompImages() {
	let images = [];
	images.push(null);
	images.push(global.ptr.subProp.GetImageByCategory("PropertyPhoto"));

	global.ptr.compList.forEach(cp => {
		images.push(cp.GetImageByCategory("PropertyPhoto"));
	});

	return images;
}

export function GetDataSources(comps) {
	let list = [];
	list.push("Data Source");
	list.push("GRAY");

	for (let cp of comps)
	{
			let rels = global.ptr.relationships.GetRelationshipsTo("DATA_SOURCE_IsDataSourceFor_PROPERTY", cp.label);
			let sources = "";
			for (let source of rels)
					sources = h.addWithSpacer(sources, global.ptr.valuationAnalysis.dataSources.GetDataSourceType(source));

			list.push(sources);
	}
	return list;
}


export function GetProximityToSubject(comps) {
	let list = [];
	list.push("Proximity to Subject");
	list.push("GRAY");

	comps.forEach(cp => {
		list.push(cp.comparable.GetProximity());
	});

	return list;
}

function GetListPrice() {
	let list = [];
	list.push("List Price");
	const amount = global.ptr.subProp.GetListPrice();

	if (amount.Value > 0 && global.ptr.bListedWithinPreviousYear) {
		list.push(amount.ToDollarAmount());
	} else {
		list.push("--");
	}

	global.ptr.compList.forEach(cp => {
		list.push(h.amountOrEmpty(cp.GetListPrice(), "--"));
	});

	return list;
}

function GetListingStatus() {
	let list = [];
	list.push("Listing Status");

	if (global.ptr.bListedWithinPreviousYear) {
		list.push(global.ptr.subProp.GetListingStatus());
	} else {
		list.push("--");
	}

	global.ptr.compList.forEach(cp => {
		list.push(cp.GetListingStatus());
	});

	return list;
}

function GetContractPrice() {
	let list = [];
	list.push("Contract Price");

	let amount = global.ptr.subSales.GetContractAmount();

	let haveData = false;
	if (amount.HasValue() && global.ptr.subSales.GetContractReviewed()) {
		list.push(amount.ToDollarAmount());
		haveData = true;
	}
	else
		list.push("--");

	global.ptr.compList.forEach(cp => {
		if (cp.comparable.comparableDetail.contractAmountUnknownIndicator ?? false) {
			list.push("Unknown");
		} else {
			amount = cp.sales.GetContractAmount();
			if (amount && amount.HasNonZeroValue()) {
				list.push(amount.ToDollarAmount());
				haveData = true;
			} else
				list.push("--");
		}
	});

	if (!haveData) return [];
	return list;
}

export function GetSalePrice(comps) {
	let list = [];
	list.push("Sale Price");
	list.push("GRAY");

	comps.forEach(cp => {
		const amount = h.amountOrEmpty(cp.sales.GetHistoryTransferAmount());
		list.push(amount);
	});

	return list;
}

function GetTransferTerms() {
	let list = [];
	list.push("Transfer Terms");
	list.push("GRAY");

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		const transfer = cp.sales.GetSalesHistoryByTransferType("Sale");

		let row1 = [];
		if (transfer === null) {
			row1.push("--");
			row1.push("");
		} else if (transfer.ownershipTransferTransactionType === "Sale") {
			row1.push(transfer.GetSaleType());
			row1.push(h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("PropertyOwnershipTransferTerms")));
			haveData = true;
		} else {
			row1.push("--");
			row1.push("");
		}
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetFinancingType() {
	let list = [];
	list.push("Financing Type")
	list.push("GRAY");

	let hasComps = false;
	global.ptr.compList.forEach(cp => {
		const mtg = cp.GetFinancingType();

		if (mtg.length > 0 && mtg !== "--") hasComps = true;

		let row1 = [];
		row1.push(mtg);
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("FinancingMethod"));
		row1.push(amount);
		list.push(row1);
	});

	return hasComps ? list : [];
}

function GetSalesConcessions() {
	let list = [];
	list.push("Sales Concessions");

	const amount = h.amountOrEmpty(global.ptr.subSales.GetConcessionAmount());
	const salesDetail = global.ptr.subSales.salesContracts[0]?.salesContractDetail;
	const bConcession = salesDetail?.salesConcessionIndicator ?? false;

	if (!bConcession) {
		list.push("No");
	} else if (!(salesDetail?.salesConcessionAmountKnownIndicator ?? false)) {
		list.push("Unknown");
	} else {
		list.push(amount);
	}

	for (const cp of global.ptr.compList) {
		const bCompConcession = cp.sales.GetConcessionIndicator();
		let row1 = [];
		if (!bCompConcession) {
			row1.push("No");
			row1.push("");
		} else if (!cp.sales.GetConcessionKnown()) {
			row1.push("Unknown");
			row1.push("");
		} else {
			const compAmount = h.amountOrEmpty(cp.sales.GetConcessionAmount());
			row1.push(compAmount);
			const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("SalesConcessions"));
			row1.push(amount);
		}
		list.push(row1);
	}

	return list;
}

function GetContractDate() {
	let list = [];
	list.push("Contract Date");

	const dt = global.ptr.subSales.GetContractDate();
	list.push((dt !== null && dt.HasFullDate()) ? dt.FormatMDY() : "--");

	global.ptr.compList.forEach(cp => {
		let row1 = [];
		const compDt = cp.sales.GetContractDate();
		row1.push(compDt == null ? "--" : compDt.FormatMDY());
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("ContractDate"));
		row1.push(amount);
		list.push(row1);
	});

	return list;
}

export function GetSaleDate(comps) {
	let list = [];
	list.push("Sale Date");
	list.push("GRAY");

	let haveData = false;
	for (const cp of comps) {
		let row1 = [];
		const date = cp.sales.GetHistoryTransferDate(true);
		if (date) haveData = true;
		let dateFmt = (date) ? date.FormatMDY() : "";
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("SaleDate"));
		row1.push(dateFmt);
		row1.push(amount);
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

function GetDaysOnMarket() {
	let list = [];
	list.push("Days on Market");
	let listing = global.ptr.subProp.GetMostRecentListing();

	if (global.ptr.bListedWithinPreviousYear) {
		const dom = listing?.listingInformationDetail?.daysOnMarketCount ?? 0;
		list.push(dom.toString());
	} else {
		list.push("--");
	}

	for (const cp of global.ptr.compList) {
		let row1 = [];
		const compListing = cp.GetMostRecentListing();
		const dom = compListing?.listingInformationDetail?.daysOnMarketCount ?? 0;
		row1.push(dom.toString());
		row1.push("GRAY");
		list.push(row1);
	}

	return list;
}

function GetSaleToListRatio() {
	let list = [];
	if (!global.ptr.subProp?.comparable?.comparableDetail)
		return list;

	let listing = global.ptr.subProp.GetListingByStatusTypeExcept("SettledSale");
	if (!listing) return list;

	list.push(h.toPercent(global.ptr.subProp.comparable.comparableDetail.saleToListPriceRatioPercent));
	
	for (const cp of global.ptr.compList) {
		list.push(h.toPercent(cp.comparable?.comparableDetail?.saleToListPriceRatioPercent));
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("SaleToListPriceRatio"));
		list.push(amount);
	}

	return list;
}

function GetAttachedDetached() {
	let list = [];
	list.push("Attached/Detached")

	list.push(h.toEnumText(global.ptr.subDetail.attachmentType))
	
	for (const cp of global.ptr.compList) {
		let row1 = [];
		row1.push(h.toEnumText(cp.propertyDetail?.attachmentType));
		row1.push("");
		list.push(row1);
	}

	return list;
}

function GetPropertyRightsAppraised() {
	let list = [];
	if (global.ptr.bInProject && !global.ptr.bCondominium) return list;
	list.push("Property Rights Appraised");
	list.push(global.ptr.subProp.GetEstateType());
	
	var haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		row1.push(cp.GetEstateType());
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("PropertyRightsAppraised"));
			row1.push(amount);
		if (amount) haveData = true;
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

function GetAnnualGroundRent() {
	let list = [];
	list.push("  Annual Ground Rent");
	const amt = h.amountOrEmpty(global.ptr.subProp.GetGroundRentAmount());
	list.push(amt);

	let haveData = false;
	for (const cp of global.ptr.compList) {
		const compAmt = h.amountOrEmpty(cp.GetGroundRentAmount());
		list.push(compAmt);
		if (compAmt) haveData = true;
	}

	if (!haveData) return [];
	return list;
}

function GetNativeAmericanLands() {
	let list = [];
	list.push("Native American Lands");
	list.push(global.ptr.subProp.GetNativeAmericanLandsType());

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let type = cp.GetNativeAmericanLandsType();
		if (type !== "No") haveData = true;
		row1.push(type);
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("NativeAmericanLands"));
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetAllRightsIncluded() {
	let list = [];
	if (global.ptr.bOwnedInCommon) return list;

	list.push("All Rights Included");
	const included = h.yesNo(global.ptr.subProp.AllRightsIncluded());
	list.push(included);

	global.ptr.compList.forEach(cp => {
		list.push(h.yesNo(cp.AllRightsIncluded()));
	});

	return list;
}

function GetRightsNotIncluded() {
	let list = [];
	list.push("  Rights Not Included");
	const rights = global.ptr.subProp.GetRightsNotIncluded();
	list.push(rights);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let rne = cp.GetRightsNotIncluded();
		list.push(rne);
		if (rne) haveData = true;
	});

	if (!haveData) return [];
	return list;
}

function GetSameBuilder() {
	let list = [];
	if (!global.ptr.subDetail.newConstructionIndicator) return list;
	list.push("Same Builder as Subject");
	list.push("GRAY");

	global.ptr.compList.forEach(cp => {
		let row1 = [];
		row1.push(h.yesNo(cp.comparable.comparableDetail.sameBuilderAsSubjectIndicator ?? false));
		row1.push("GRAY");
		list.push(row1);
	});

	return list;
}

/*******************************************************************************/
// 
//  Project Information
// 
/*******************************************************************************/

function GetProjectNameAndSame() {
    const list = [];
		list.push("Project Name | Same\nProject as Subject");
    list.push(global.ptr.subProj.projectDetail.projectName);
    global.ptr.compList.forEach(cp => {
        let ns = cp.project.projectDetail.projectName;
        ns = h.addWithSpacer(ns, h.yesNo(cp.comparable.comparableDetail.sameProjectAsSubjectIndicator));
        list.push(ns);
    });
    return list;
}

function GetProjectMonthlyFee() {
    const list = [];
		list.push("Monthly Fee");
    list.push(global.ptr.subProp.homeownersAssociations.GetAssociationChargeAmount("AssociationDues"));
    global.ptr.compList.forEach(cp =>
        list.push(cp.homeownersAssociations.GetAssociationChargeAmount("AssociationDues"))
    );
    return list;
}

function GetProjectCommonAmenities() {
    const list = [];
		list.push("Common Amenities/Services");
    list.push(global.ptr.subProj.GetAmenities(" | "));
    global.ptr.compList.forEach(cp =>
        list.push(cp.project.GetAmenities(" | "))
    );
    return list;
}

function GetProjectSpecialAssessments() {
    const list = [];
		list.push("Special Assessments");
    list.push(global.ptr.subProp.homeownersAssociations.GetSpecialAssessmentStatusType());
		let haveData = false;
    global.ptr.compList.forEach(cp => {
        let type = cp.homeownersAssociations.GetSpecialAssessmentStatusType();
				if (type !== null) {
        	list.push(type)
					haveData = true;
				}
				else {
	       	list.push("")
				}
		});
		if (!haveData) return [];
    return list;
}

/*******************************************************************************/
// 
//  Site
// 
/*******************************************************************************/

function GetSiteOwnedInCommon() {
	let list = [];
	list.push("Site Owned In Comman");
	list.push(h.yesNo(global.ptr.subSite.siteDetail.landOwnedInCommonIndicator));

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let oic = cp.site.siteDetail.landOwnedInCommonIndicator;
		row1.push(h.yesNo(oic));
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("LandOwnedInCommon"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetSiteSize() {
	let list = [];
	if (!global.ptr.subSite.siteSizeLayout) return list;

	const area = global.ptr.subSite.siteSizeLayout.lotSizeAreaMeasure.ToString();
	if (!area) return list;

	list.push("Site Size");
	list.push(area);

	global.ptr.compList.forEach(cp => {
		let row1 = [];
		row1.push(cp.site.siteSizeLayout.lotSizeAreaMeasure.ToString());
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("SiteSize"));
		row1.push(amount);
		list.push(row1);
});

	return list;
}

function GetSiteNeighborhoodName() {
  let list = [];
	if (global.ptr.subProp.neighborhood === null) return list;
	list.push("Neighborhood Name");
	const name = global.ptr.subProp.neighborhood.neighborhoodDetail.neighborhoodName;
	list.push(name);

	let hasComps = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		const name = cp.neighborhood?.neighborhoodDetail.neighborhoodName
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("NeighborhoodName"));

		if (name || amount) {
			row1.push(name);
			row1.push(amount);
			hasComps = true;
		} else {
			row1.push("", "");
		}
		list.push(row1);
	});

	if (!hasComps) return [];
	return list;
}

function GetSiteZoningCompliance() {
  let list = [];
	list.push("Zoning Compliance");
	const attached = h.toEnumText(global.ptr.subSite.siteZoning.siteZoningDetail.siteZoningComplianceType);
	list.push(attached);

	let hasComps = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		if (cp.site.siteZoning == null) {
			row1.push("");
			row1.push("$0");
		} else {
			row1.push(h.toEnumText(cp.site.siteZoning.siteZoningDetail.siteZoningComplianceType));
			const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("ZoningCompliance"));
			row1.push(amount);
			hasComps = true;
		}
		list.push(row1);
	}

    return hasComps ? list : [];
}

function GetSiteHazardZone() {
  let list = [];
	list.push("Hazard Zone");
	let item = global.ptr.subSite.GetHazardZones();
	if (item === "None") item = "No Hazard Zone Noted";
	list.push(item);

	let haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		item = cp.site.GetHazardZones();
		if (item && item !== "None") haveData = true;
		if (item === "None") {
				row1.push("No Hazard Zone Noted");
				row1.push("");
		} else {
				row1.push(item);
				const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("HazardZone"));
				row1.push(amount);
		}
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

function GetSitePrimaryAccess() {
  let list = [];
	list.push("Primary Access");
  if (global.ptr.subSite.siteDetail.LandOwnedInCommonIndicator ?? false) return list;

	list.push(global.ptr.subSite.GetEntryExitType());
	let haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		let eet = cp.site.GetEntryExitType();
		if (!h.isEmpty(eet)) haveData = true;
		row1.push(eet ?? "");
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("PropertyPrimaryAccess"));
		row1.push(amount);
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

function GetSiteStreetTypeSurface() {
  let list = [];

	const eeType = global.ptr.subSite.GetEntryExitType();
	if (eeType !== "Public Street" && eeType !== "Private Street") return list;

	const access = global.ptr.subSite.GetStreetAccessTypes();
	if (!access) return list;

	list.push("Street Type | Surface");
	list.push(access);

	for (const cp of global.ptr.compList) {
		let row1 = [];
		row1.push(cp.site.GetStreetAccessTypes() ?? "");
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("PropertyStreetAccessAndSurface"));
		row1.push(amount);
		list.push(row1);
	}

	return list;
}

function GetSitePropertyRestriction() {
  let list = [];

	const r = global.ptr.subProp.GetPropertyRestrictions();
	if (!r) return list;

	list.push("Property Restriction");
	list.push(r);

	let haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		const restriction = cp.GetPropertyRestrictions();
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("PropertyRestriction"));
		if (restriction || amount) {
			row1.push(h.isEmpty(restriction) ? "--" : restriction);
			row1.push(amount);
			haveData = true;
		} else {
			row1.push("", "");
		}
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

function GetSiteEasement() {
	let list = [];
	const r = global.ptr.subProp.GetEasements();
	if (!r) return list;

	list.push("Easement");
	list.push(r);
	for (const cp of global.ptr.compList) {
		let row1 = [];
		const easement = cp.GetEasements();
		if (easement) {
			row1.push(easement);
			const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("Easement"));
			row1.push(amount);
		} else {
			row1.push("", "");
		}
		list.push(row1);
	}

	return list;
}

function GetSiteTopography() {
	let list = [];
	const item = global.ptr.subSite.GetTopography();
	if (!item) return [];
	list.push("Topography");
	list.push(item);

	let haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		let topo = cp.site.GetTopography();
		if (topo) haveData = true;
		row1.push(topo);
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("Topography"));
		row1.push(amount);
		list.push(row1);
	}

if (!haveData) return [];
	return list;
}

function GetSiteDrainage() {
	let list = [];
	const d = global.ptr.subSite.GetDrainage();
	if (!d)	return list;

	list.push("Drainage");
	list.push(d);

	for (const cp of global.ptr.compList) {
		let row1 = [];
		const drainage = cp.site.GetDrainage();
		if (drainage) {
			row1.push(drainage);
			const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("Easement"));
			row1.push(amount);
		} else {
			row1.push("", "");
		}
		list.push(row1);
	}

	return list;
}

function GetSiteCharacteristics() {
	let list = [];
	list.push("Site Characteristics");
	list.push(global.ptr.subSite.GetSiteCharacteristics());

	let haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		const sc = cp.site.GetSiteCharacteristics();
		if (!h.isEmpty(sc)) haveData = true
		row1.push(sc);
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("SiteCharacteristic"));
		row1.push(amount);
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

function GetSiteInfluenceLocation() {
	let list = [];
	list.push("Site Influence (Location)");
	list.push(global.ptr.subSite.GetInfluence());

	let haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		const inf = cp.site.GetInfluence();
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("SiteInfluence"));
		if (!h.isEmpty(inf) || amount ) {
			row1.push(inf);
			row1.push(amount);
			haveData = true;
		} else {
			row1.push("", "");
		}
		list.push(row1);
	}
	if (!haveData) return [];
	return list;
}

function GetSiteApparentEnvironmentalConditions() {
	let list = [];
	list.push("Apparent Environmental Conditions");
	list.push(global.ptr.subProp.GetEnvironmentalConditionTypes());

	let haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		const et = cp.GetEnvironmentalConditionTypes();
		if (!h.isEmpty(et)) haveData = true;
		row1.push(et ?? "");
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("ApparentEnvironmentalCondition"));
		row1.push(amount);
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}
function GetSiteViewRange() {
	let list = [];
	list.push("View | Range")
	list.push(global.ptr.subSite.GetViewRange());

	for (const cp of global.ptr.compList) {
		let row1 = [];
		row1.push(cp.site.GetViewRange());
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("View"));
		row1.push(amount);
		list.push(row1);
	}

	return list;
}

/*******************************************************************************/
// 
//  Water Frontage
// 
/*******************************************************************************/

function GetWaterFrontage() {
	let list =[];
	// Check for private access for subject and comps
	if (!global.ptr.valuationAnalysis.GetPrivateWaterAccess()) return list;

	list.push(global.ptr.subProp.site.GetBodiesOfWaterDetails());

	global.ptr.compList.forEach(cp => {
		list.push(cp.site.GetBodiesOfWaterDetails());
	});

	return list;
}

function GetWaterFrontagePermanentWaterfrontFeature() {
	// Check for private access for subject and comps
	let list =[];
	if (!global.ptr.valuationAnalysis.GetPrivateWaterAccess()) return list;

	list.push(global.ptr.subProp.site.GetWaterfrontFeatures());

	global.ptr.compList.forEach(cp => {
		list.push(cp.site.GetWaterfrontFeatures());
	});

	return list;
}

function GetWaterFrontageRightToBuild() {
	// If there are no features, can you build one?
	let list =[];
	if (!global.ptr.valuationAnalysis.GetHasWaterfrontFeatures()) return list;

	list.push(global.ptr.subProp.site.GetRightToBuild());

	global.ptr.compList.forEach(cp => {
		list.push(cp.site.GetRightToBuild());
	});

	return list;
}

function GetWaterFrontageTotalLinearMeasurement() {
	let list =[];
	list.push(global.ptr.subProp.site.GetWaterFrontageTotalLinearMeasurement());

	global.ptr.compList.forEach(cp => {
		list.push(cp.site.GetWaterFrontageTotalLinearMeasurement());
	});

	return list;
}

/*******************************************************************************/
// 
//  Dwellings
// 
/*******************************************************************************/

function GetDwellingsYearBuilt() {
	let list = [];
	list.push("Year Built");

	let yb = "";
	for (const imp of global.ptr.subDwellingList) {
		let year = imp.improvementDetail.propertyStructureBuiltYear;
		if (year)	yb = h.addWithSpacer(yb, year)
	}
	list.push(yb);

	let haveData = false;
	for (const cp of global.ptr.compList) {
		yb = "";
		for (let imp of cp.improvements.improvementList) {
			let year = imp.improvementDetail.propertyStructureBuiltYear;
			if (year)	yb = h.addWithSpacer(yb, year)
		}

		if (yb) haveData = true;
		let row1 = [];
		row1.push(yb);
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("YearBuilt"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

function GetDwellingsStructureDesign() {
	const list = [];
	list.push("Structure Design")

	let item = '';
	global.ptr.subDwellingList.forEach(i => {
		item = h.addWithSpacer(item, i.structure.GetStructuralDesignType());
	});
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		item = '';
		for (let i of cp.improvements.improvementList) {
			if (i.improvementDetail.improvementType === "Dwelling") {
				item = h.addWithSpacer(item, i.structure.GetStructuralDesignType());
			};
		}

		if (item) haveData = true;
		row1.push(item);
		row1.push(h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("StructureDesign")));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetDwellingsGrossBuildingFinishedArea() {
	let list = [];
	list.push("Gross Building Finished Area");
	list.push(global.ptr.subDetail.totalFinishedAreaOfAllLivingUnitsIncludingADUAreaMeasure.ToString());

	let haveData = false;
	for (const cp of global.ptr.compList) {
		let row1 = [];
		let measure = cp.propertyDetail.totalFinishedAreaOfAllLivingUnitsIncludingADUAreaMeasure;
		if (measure.HasValue()) haveData = true;
		row1.push(measure.ToString());
		const amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("GrossBuildingFinishedArea"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

// Get non-continuous finished area data
function GetDwellingsNoncontinuousFinishedArea() {
	let list = [];
	list.push("Noncontinuous\nFinished Area");

	if (global.ptr.dwelling.improvementDetail.nonContinuousFinishedAreaIndicator ?? false) {
		list.push(global.ptr.dwelling.structure.structureDetail.structureNonContinuousFinishedAreaMeasure.ToString());
	} else {
		list.push("0");
	}

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let measure = cp.improvements.improvementList[0].structure.structureDetail.structureNonContinuousFinishedAreaMeasure;
		if (measure.HasValue()) haveData = true;
		row1.push(measure.ToString());
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("NonContinuousFinishedArea"));
		if (amount) haveData = true;
		row1.push(amount);
	
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

// Get townhouse end unit data
function GetDwellingsTownhouseEndUnit() {
	let list = [];
	list.push("Townhouse End Unit");
	list.push(h.yesNo(global.ptr.dwelling.structure.structureDetail.rowhouseTownhouseEndUnitIndicator ?? false));

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let end = cp.improvements.improvementList[0].structure.structureDetail.rowhouseTownhouseEndUnitIndicator ?? false;
		if (end) haveData = true;
		row1.push(h.yesNo(end));
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("RowhouseTownhouseEndUnit"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

// Get townhouse back-to-back data
function GetDwellingsTownhouseBackToBack() {
	let list = [];
	list.push("Townhouse Back to Back");
	list.push(h.yesNo(global.ptr.subDwelling.structure.structureDetail.rowhouseTownhouseBackToBackIndicator ?? false));

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let btb = cp.improvements.improvementList[0].structure.structureDetail.rowhouseTownhouseBackToBackIndicator ?? false;
		if (btb) haveData = true;
		row1.push(h.yesNo(btb));
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("RowhouseTownhouseBackToBack"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

// Get townhouse location data
function GetDwellingsTownhouseLocation() {
	let list = [];

	const design = global.ptr.subDwelling.structure.GetStructuralDesignType();
	if (!design.includes("Townhouse")) return list;

	list.push("Townhouse Location");

	let bStacked = global.ptr.subDwelling.structure.structureDetail.rowhouseTownhouseStackedIndicator ?? false;
	if (bStacked) {
		list.push(h.toEnumText(global.ptr.subDwelling.structure.structureDetail.rowhouseTownhouseLocationType));
	} else {
		list.push("No Units Above/Below");
	}

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		bStacked = cp.improvements.improvementList[0].structure.structureDetail.rowhouseTownhouseStackedIndicator ?? false;
		if (bStacked) {
			haveData = true;
			row1.push(h.toEnumText(cp.improvements.improvementList[0].structure.structureDetail.rowhouseTownhouseLocationType));
		} else {
			row1.push("No Units Above/Below");
		}
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("RowhouseTownhouseLocation"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

// Get construction method data
function GetDwellingsConstructionMethod() {
	let list = [];
	list.push("Construction Method");
	const item = global.ptr.subDwelling.structure.GetConstructionMethods();
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let cm = cp.improvements.improvementList[0].structure.GetConstructionMethods();
		if (cm)	haveData = true;
		row1.push(cm);
		row1.push(h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("ConstructionMethod")));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

// Get manufactured home width data
function GetDwellingsManufacturedHomeWidth() {
	let list = [];
	list.push("Manufactured Home Width");
	const item = global.ptr.subDwelling.GetManufacturedHomeWidth();
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let w = cp.improvements.improvementList[0].GetManufacturedHomeWidth();
		if (w) haveData = true;
		row1.push(w);
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("ManufacturedHomeWidth"));
		if (amount)	haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

// Get dwelling style data
function GetDwellingsDwellingStyle() {
	let list = [];
	list.push("Dwelling Style");
	list.push(global.ptr.subProp.GetDwellingStyles());

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let ds = cp.GetDwellingStyles();
		if (ds) haveData = true;
		row1.push(ds);
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("DwellingStyle"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetDwellingsTotalDwellingVolume() {
	const list = [];
	list.push("Total Dwelling Volume");
	const item = global.ptr.subDetail.totalOfAllDwellingsVolumeMeasure.ToString();
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let measure = cp.propertyDetail.totalOfAllDwellingsVolumeMeasure;
		if (measure.HasValue()) haveData = true;
		row1.push(measure.ToString());
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("TotalDwellingVolume"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetDwellingsWindowSurfaceArea() {
	const list = [];
	list.push("Window Surface Area");
	const item = global.ptr.subDetail.totalWindowSurfaceAreaOfAllDwellingsAreaMeasure.ToString();
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let measure = cp.propertyDetail.totalWindowSurfaceAreaOfAllDwellingsAreaMeasure;
		if (measure.HasValue()) haveData = true;
		row1.push(measure.ToString());
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("WindowSurfaceArea"));
		if (amount)	haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetDwellingsFunctionalIssues() {
	const list = [];
	list.push("Functional Issues");
	const item = global.ptr.subProp.GetFunctionalIssues();
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let fi = cp.GetFunctionalIssues();
		if (fi && fi !== "None") haveData = true;
		row1.push(fi);
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("FunctionalIssues"));
		if (amount) haveData = true;
			row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetDwellingsDisasterMitigation() {
	const list = [];
	const item = global.ptr.subProp.disasterMitigation.GetFeatures();
	if (item === "None") return list;
	list.push("Disaster Mitigation")
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let f = cp.disasterMitigation.GetFeatures();
		if (f) haveData = true;
		row1.push(f);
		let amount = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("DisasterMitigationFeatures"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetDwellingsHeating() {
	const list = [];
	const item = global.ptr.subDwellingList[0].system.GetHeatingSystems();
	list.push("Heating")
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let hs = cp.improvements.improvementList[0].system.GetHeatingSystems();
		if (hs) haveData = true;
		row1.push(hs);
		row1.push(h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("HeatingSystem")))
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetDwellingsCooling() {
	const list = [];
	const item = global.ptr.subDwellingList[0].system.GetCoolingSystems();
	list.push("Cooling")
	list.push(item);

	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let row1 = [];
		let cs = cp.improvements.improvementList[0].system.GetCoolingSystems();
		if (cs) haveData = true;
		row1.push(cs);
		row1.push(h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("CoolingSystem")));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

/*******************************************************************************/
// 
//  Energy Efficiency
// 
/*******************************************************************************/

function GetEnergyRenewableEnergyComponent() {
	let list = [];
	if (!global.ptr.subProp.energyEfficiencyAndGreen.GetRenewableEnergyComponentExists()) return list;

	let item = global.ptr.subProp.energyEfficiencyAndGreen.GetEnergyComponents();
	if (!item || item === "None") return list;

	list.push("Renewable Energy\nComponent");
	list.push(item);

	let haveData = false;
	for (let cp of global.ptr.compList) {
		let ec = list.push(cp.energyEfficiencyAndGreen.GetEnergyComponents());
		if (ec) haveData = true;
		list.push(ec);
	}

	if (!haveData) return [];
	return list;
}

function GetEnergyBuildingCertification() {
  let list = [];
	if (!global.ptr.subProp.energyEfficiencyAndGreen.GetGreenCertificationExists()) return list;

	list.push("Building Certification");
	let item = global.ptr.subProp.energyEfficiencyAndGreen.GetCertifications();
	list.push(item);

	let haveData = false;
	for (let cp of global.ptr.compList) {
		let e = cp.energyEfficiencyAndGreen;
		if (e) {
			haveData = true;
			list.push(e.GetCertifications());
		} else {
			list.push("");
		}
	}

	if (!haveData) return [];
	return list;
}

function GetEnergyEfficiencyRating() {
	let list = [];
	if (!global.ptr.subProp.energyEfficiencyAndGreen.GetEfficiencyRatingExists()) return list;

	list.push("Efficiency Rating");
	const item = global.ptr.subProp.energyEfficiencyAndGreen.GetRating();
	list.push(item);

	// Add ratings from comparable properties
	let haveData = false;
	global.ptr.compList.forEach(cp => {
		let e = cp.energyEfficiencyAndGreen;
		if (e) {
			let r = e.GetRating();
			if (r) haveData = true;
			if (!r) r = "None";
			list.push(r);
		}
	});

	if (!haveData) return [];
	return list;
}

/*******************************************************************************/
// 
//  Units
// 
/*******************************************************************************/
function GetUnitsIDs(pu, cpu) {
	let list = [];
	if (global.ptr.subLivingUnitCount <= 1) return list;
	if (!global.ptr.valuationAnalysis.ADUsExist()) return list;

	list.push("!Structure ID | Unit ID");

	let bid = pu.parentImprovement.structure.structureDetail.structureIdentifier;
	bid = h.addWithSpacer(bid, pu.propertyUnitDetail.unitIdentifier);
	list.push(bid);

	cpu.forEach(puc => {
		let bid = puc.parentImprovement.structure.structureDetail.structureIdentifier;
		bid = h.addWithSpacer(bid, puc.propertyUnitDetail.unitIdentifier);
		list.push(bid);
	})

	return list;
}

function GetUnitsLocationOfADU(pu, cpu) {
	let list = [];
	if (!global.ptr.valuationAnalysis.ADUsExist()) return list;
	if (!pu.propertyUnitDetail.accessoryDwellingUnitIndicator) return list;

	list.push("!Location of ADU");
	let loc = pu.GetADULocation();
	list.push("!"+loc);

	for (let cp of cpu) {
		let row1 = [];
		loc = cp.GetADULocation();
		row1.push("!"+loc);
		row1.push("!"+h.amountOrEmpty(cp.parentProperty.comparable.GetComparableAdjustmentAmount("AccessoryDwellingUnitLocation")));
		list.push(row1);
	}
	return list;
}

function GetUnitsFloorNumber(pu, cpu) {
	const list = [];

	list.push("Floor Number");
	list.push(pu.propertyUnitDetail.floorIdentifier);

	let haveData = false;
	cpu.forEach(puc => {
		let row1 = [];
		row1.push(puc.propertyUnitDetail.floorIdentifier);
		let amount = h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitFloorNumber"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetUnitsCornerUnit(pu, cpu) {
	const list = [];

	list.push("Corner Unit");
	list.push(h.yesNo(pu.propertyUnitDetail.cornerUnitIndicator ?? false));

	let haveData = false;
	cpu.forEach(puc => {
		let row1 = [];
		row1.push(h.yesNo(puc.propertyUnitDetail.cornerUnitIndicator ?? false));
		row1.push(h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("CornerUnit")));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetUnitsLevelsInUnit(pu, cpu) {
	const list = [];

	let haveData = false;
	list.push("Levels in Unit");
	let levels = pu.GetLevelCount();
	if (Number(levels) > 1) haveData = true;
	list.push(levels);

	cpu.forEach(puc => {
		let row1 = [];
		row1.push(puc.GetLevelCount());
		let amount = h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitLevelCount"));
		if (amount) haveData = true;
		row1.push(amount);
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetUnitsBedrooms(pu, cpu) {
	const list = [];

	list.push("Bedrooms");
	list.push(pu.propertyUnitDetail.bedroomCount.toString());

	cpu.forEach(puc => {
		let row1 = [];
		row1.push(puc.propertyUnitDetail.bedroomCount.toString());
		const amount = h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitBedroomCount", puc.propertyUnitDetail.unitIdentifier));
		row1.push(amount);
		list.push(row1);
	});

	return list;
}

function GetUnitsBathsFullHalf(pu, cpu) {
	const list = [];

	list.push("Baths - Full | Half");
	let item = pu.propertyUnitDetail.fullBathroomCount.toString();
	item = h.addWithSpacer(item, pu.propertyUnitDetail.halfBathroomCount.toString());
	list.push(item);

	cpu.forEach(puc => {
		item = puc.propertyUnitDetail.fullBathroomCount.toString();
		item = h.addWithSpacer(item, puc.propertyUnitDetail.halfBathroomCount.toString());
		let row1 = [];
		row1.push(item);
		const amount = h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitBathroomCount"));
		row1.push(amount);
		list.push(row1);
	});

	return list;
}

function GetUnitsFinishedAreaAboveGrade(pu, cpu) {
	const list = [];

	list.push("Finished Area Above Grade");
	let measure = pu.propertyUnitArea.unitStandardAboveGradeFinishedAreaMeasure;
	list.push(measure.ToString());
	
	cpu.forEach(puc => {
		let row1 = [];
		let measure = puc.propertyUnitArea.unitStandardAboveGradeFinishedAreaMeasure;
		row1.push(measure.ToString());
		row1.push(h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitStandardFinishedAreaAboveGrade",	puc.propertyUnitDetail.unitIdentifier)));
		list.push(row1);
	});

	return list;
}

function GetUnitsFinishedAreaAboveGradeNonstandard(pu, cpu) {
	const list = [];

	list.push("Finished Area Above\nGrade (Nonstandard)");
	let measure = pu.propertyUnitArea.unitNonStandardAboveGradeFinishedAreaMeasure;
	list.push(measure.ToString());

	let haveData = false;
	cpu.forEach(puc => {
		let row1 = [];
		let measure = puc.propertyUnitArea.unitNonStandardAboveGradeFinishedAreaMeasure;
		row1.push(measure.ToString());
		row1.push(h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitNonStandardFinishedAreaAboveGrade", puc.propertyUnitDetail.unitIdentifier)));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetUnitsUnfinishedAreaAboveGrade(pu, cpu) {
	const list = [];

	list.push("Unfinished Area Above\nGrade");
	let measure = pu.propertyUnitArea.unitAboveGradeUnfinishedAreaMeasure;
	list.push(measure.ToString());

	let haveData = false;
	cpu.forEach(puc => {
		let row1 = [];
		let measure = puc.propertyUnitArea.unitAboveGradeUnfinishedAreaMeasure;
		row1.push(measure.ToString());
		row1.push(h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitUnfinishedAreaAboveGrade",	puc.propertyUnitDetail.unitIdentifier)));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetUnitsFinishedAreaBelowGrade(pu, cpu) {
	const list = [];

	list.push("Finished Area Below Grade");
	let measure = pu.propertyUnitArea.unitStandardBelowGradeFinishedAreaMeasure;
	list.push(measure.ToString());

	cpu.forEach(puc => {
		let row1 = [];
		let measure = puc.propertyUnitArea.unitStandardBelowGradeFinishedAreaMeasure;
		row1.push(measure.ToString());
		row1.push(h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitStandardFinishedAreaBelowGrade",	puc.propertyUnitDetail.unitIdentifier)));
		list.push(row1);
	});

	return list;
}

function GetUnitsFinishedAreaBelowGradeNonstandard(pu, cpu) {
	const list = [];

	list.push("Finished Area Below Grade\n(Nonstandard)");
	let measure = pu.propertyUnitArea.unitNonStandardBelowGradeFinishedAreaMeasure;
	list.push(measure.ToString());

	let haveData = false;
	cpu.forEach(puc => {
		let row1 = [];
		let measure = puc.propertyUnitArea.unitNonStandardBelowGradeFinishedAreaMeasure;
		row1.push(measure.ToString());
		row1.push(h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitNonStandardFinishedAreaBelowGrade", puc.propertyUnitDetail.unitIdentifier)));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetUnitsUnfinishedAreaBelowGrade(pu, cpu) {
	const list = [];

	list.push("Unfinished Area Below Grade");
	let measure = pu.propertyUnitArea.unitBelowGradeUnfinishedAreaMeasure;
	list.push(measure.ToString());

	let haveData = false;
	cpu.forEach(puc => {
		let row1 = [];
		let measure = puc.propertyUnitArea.unitBelowGradeUnfinishedAreaMeasure;
		if (measure.HasValue()) haveData = true;
		row1.push(measure.ToString());
		row1.push(h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitUnfinishedAreaBelowGrade",	puc.propertyUnitDetail.unitIdentifier)));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

function GetUnitsFeaturesForIndividualsWithDisabilities(pu, cpu) {
	const list = [];

	list.push("Features for Individuals\nw/Disabilities");
	list.push(pu.GetAccessibilityFeatures());

	let haveData = false;
	cpu.forEach(puc => {
		let row1 = [];
		row1.push(puc.GetAccessibilityFeatures());
		row1.push(h.amountOrEmpty(puc.parentProperty.comparable.GetComparableAdjustmentAmount("LivingUnitFeaturesForIndividualsWithDisabilities",	puc.propertyUnitDetail.unitIdentifier)));
		list.push(row1);
	});

	if (!haveData) return [];
	return list;
}

/*******************************************************************************/
// 
//  Exterior Quality and Condition
// 
/*******************************************************************************/
function GetQCExteriorStructureID(sub, comps) {
  const list = [];
	let id = sub.structure.structureDetail.structureIdentifier;
	if (!id) return list;

	list.push("!Structure ID");
	list.push("^"+id);

	for (const ci of comps) {
		if (!ci)
			list.push("--");
		else
			list.push("^"+ci.structure.structureDetail.structureIdentifier);
	}

	return list;
}
function GetQCExteriorQuality(sub, comps) {
    const list = [];
    let item = sub.structure.structureDetail.exteriorQualityRatingCode;
		if (!item) return list;

		list.push("!Quality");
    list.push(item);

    for (const ci of comps) {
			if (!ci)
				list.push("--");
			else
        list.push(ci.structure.structureDetail.exteriorQualityRatingCode);
		}
    return list;
}

function GetQCExteriorQualityExteriorWallsAndTrim(sub, comps) {
  const list = [];
  let item = sub.structure.GetWallMaterials();
  if (!item) return list;

  list.push("  Exterior Walls and Trim");
  list.push(item);

  let haveData = false;
  for (const cp of comps) {
		if (!cp)
			list.push("--");
		else {
		let val = cp.structure.GetWallMaterials();
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("--");
  	}
	}
  if (!haveData) return [];
  return list;
}

function GetQCExteriorQualityFoundationQuality(sub, comps) {
  const list = [];
  let item = sub.structure.GetFoundationQuality();
  if (!item) return list;
  list.push("  Foundation");
  list.push(item);

  let haveData = false;
  for (const cp of comps) {
		if (!cp)
			list.push("--");
		else {
			let val = cp.structure.GetFoundationQuality();
			if (val) {
				list.push(val);
				haveData = true;
			} else
				list.push("--");
		}
	}
  if (!haveData) return [];
  return list;
}

function GetQCExteriorQualityFoundation(sub, comps) {
  const list = [];
  list.push("  Foundation Styles");
  let item = sub.structure.GetFoundationStyles();
  if (!item) return list;
  list.push(item);

  let haveData = false;
  for (const cp of comps) {
   		if (!cp)
			list.push("--");
		else {
			let val = cp.structure.GetFoundationStyles();
					if (val) {
						list.push(val);
						haveData = true;
					} else
						list.push("--");
				}
			}
  if (!haveData) return [];
  return list;
}

function GetQCExteriorQualityRoof(sub, comps) {
  const list = [];
  list.push("  Roof");
  let item = sub.structure.GetRoofMaterials();
  if (!item) return list;
  list.push(item);

  let haveData = false;
  for (const cp of comps) {
		if (!cp)
			list.push("--");
		else {
      let val = cp.structure.GetRoofMaterials();
			if (val) {
	      list.push(val);
	      haveData = true;
			} else
	      list.push("--");
    }
	}

  if (!haveData) return [];
  return list;
}

function GetQCExteriorQualityWindows(sub, comps) {
  const list = [];
  let component = sub.structure.GetStructureComponent("Windows");
  if (!component) return list;

  list.push("  Windows");
  list.push(
    component.structureComponentDetail.improvementComponentQualitySummaryDescription
  );

  let haveData = false;
  for (const cp of comps) {
 		if (!cp)
			list.push("--");
		else {
	    component = cp.structure.GetStructureComponent("Windows");
      if (!component) {
        list.push("");
      } else {
        let val = component.structureComponentDetail.improvementComponentQualitySummaryDescription;
				if (val) {
					list.push(val);
					haveData = true;
				} else
					list.push("--");
      }
		}
  }

  if (!haveData) return [];
  return list;
}

function GetQCExteriorCondition(sub, comps) {
	let list = [];
	list.push("!Condition");
	list.push(sub.structure.structureDetail.exteriorConditionRatingCode);

	for (const cp of comps) {
		if (!cp)
			list.push("--");
		else 
			list.push(cp.structure.structureDetail.exteriorConditionRatingCode);
	}
	return list;
}

function GetQCExteriorConditionExteriorWallsAndTrim(sub, comps) {
  let list = [];
  list.push("  Exterior Walls and Trim");
  let item = sub.structure.GetComponentConditions("ExteriorWallsAndTrim");
  if (!item) return list;
  list.push(item);

  let haveData = false;
  for (const cp of comps) {
		if (!cp)
			list.push("--");
		else {
			let cond = cp.structure.GetComponentConditions("ExteriorWallsAndTrim");
			if (cond) {
				list.push(cond);
				haveData = true;
			} else list.push("--");
 	 }
	}

  if (!haveData) return [];
  return list;
}

function GetQCExteriorConditionFoundation(sub, comps) {
	let list = [];
	let component = sub.structure.GetStructureComponent("Foundation");
	if (!component) return list;

	list.push("  Foundation");
	list.push(component.GetCondition());

	let haveData = false;
	for (const cp of comps) {
		if (!cp)
			list.push("--");
		else {
			component = cp.structure.GetStructureComponent("Foundation");
			if (!component) {
				list.push("");
			} else {
				let cond = component.GetCondition();
				if (cond) {
					list.push(cond);
					haveData = true;
				} else
					list.push("--");
			}
		}
	}

	if (!haveData) return [];
	return list;
}

function GetQCExteriorConditionRoof(sub, comps) {
	let list = [];
	let component = sub.structure.GetStructureComponent("Roof");
	if (!component) return list;

	list.push("  Roof");
	list.push(component.GetCondition());

	let haveData = false;
	for (const cp of comps) {
		if (!cp)
			list.push("--");
		else {
			component = cp.structure.GetStructureComponent("Roof");
			if (!component) {
				list.push("");
			} else {
				let cond = component.GetCondition();
				if (cond) {
					list.push(cond);
			    haveData = true;
				} else
					list.push("--");
			}
		}
	}

	if (!haveData) return [];
	return list;
}

function GetQCExteriorConditionWindows(sub, comps) {
	let list = [];
	let component = sub.structure.GetStructureComponent("Windows");
	if (!component) return list;

	list.push("  Windows");
	list.push(component.GetCondition());

	let haveData = false;
	for (const cp of comps) {
		if (!cp)
			list.push("--");
		else {
			component = cp.structure.GetStructureComponent("Windows");
			if (!component) {
				list.push("");
			} else {
				let cond = component.GetCondition();
				if (cond) {
					list.push(cond);
			    haveData = true;
				} else
					list.push("--");
			}
		}
	}

	if (!haveData) return [];
	return list;
}

/*******************************************************************************/
// 
//  Interior Quality and Condition
// 
/*******************************************************************************/

function GetQCInteriorStructureID(pu, cpu) {
	const list = [];

	list.push("!Structure ID | Unit ID");

	let bid = pu.parentImprovement.structure.structureDetail.structureIdentifier;
	bid = h.addWithSpacer(bid, pu.propertyUnitDetail.unitIdentifier);
	list.push(bid);

	cpu.forEach(puc => {
		let bid = puc.parentImprovement.structure.structureDetail.structureIdentifier;
		bid = h.addWithSpacer(bid, puc.propertyUnitDetail.unitIdentifier);
		list.push(bid);
	})


	return list;
}

function GetQCInteriorQuality(pu, cpu) {
	const list = [];

	list.push("!Quality");
	var val = pu.propertyUnitDetail.interiorQualityRatingCode;
	list.push(val);
	
	let haveData = false;
	cpu.forEach(puc => {
		var val = puc.propertyUnitDetail.interiorQualityRatingCode;
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("");
	});

	if (!haveData) return [];
	return list;
}

function GetQCInteriorQualityKitchen(pu, cpu) {
	const list = [];

	list.push("  Kitchen");
	var val = pu.GetRoomQuality("Kitchen");
	list.push(val);

	let haveData = false;
	cpu.forEach(puc => {
		var val = puc.GetRoomQuality("Kitchen");
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("");

	});

	if (!haveData) return [];
	return list;
}

function GetQCInteriorQualityOverallBathrooms(pu, cpu) {
	const list = [];

	list.push("  Overall Bathrooms");
	var val = pu.propertyUnitDetail.overallBathroomsQualityDescription;
	list.push(val);

	let haveData = false;
	cpu.forEach(puc => {
		var val = puc.propertyUnitDetail.overallBathroomsQualityDescription;
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("");

	});

	if (!haveData) return [];
	return list;
}

function GetQCInteriorQualityOverallFlooring(pu, cpu) {
	const list = [];
	
	list.push("  Overall Flooring");
	var val = pu.GetComponentQuality("Flooring");
	list.push(val);

	let haveData = false;
	cpu.forEach(puc => {
		var val = puc.GetComponentQuality("Flooring");
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("");

	});

	if (!haveData) return [];
	return list;
}

function GetQCInteriorQualityWallsAndCeiling(pu, cpu) {
	const list = [];

	list.push("  Walls and Ceiling");
	var val = pu.GetComponentQuality("WallsAndCeiling");
	list.push(val);

	let haveData = false;
	cpu.forEach(puc => {
		var val = puc.GetComponentQuality("WallsAndCeiling");
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("");

	});

	if (!haveData) return [];
	return list;
}

function GetQCInteriorCondition(pu, cpu) {
	const list = [];

	list.push("!Condition");
	var val = pu.propertyUnitDetail.interiorConditionRatingCode;
	list.push(val);

	cpu.forEach(puc => {
		var val = puc.propertyUnitDetail.interiorConditionRatingCode;
		list.push(val);
	});

	return list;
}

function GetQCInteriorConditionKitchen(pu, cpu) {
	const list = [];

	list.push("  Kitchen");
	var val = pu.GetRoomCondition("Kitchen");
	list.push(val);

	let haveData = false;
	cpu.forEach(puc => {
		var val = puc.GetRoomCondition("Kitchen");
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("");

	});

	if (!haveData) return [];
	return list;
}

function GetQCInteriorConditionOverallBathrooms(pu, cpu) {
	const list = [];

	list.push("  Overall Bathrooms");
	list.push(h.toEnumText(pu.propertyUnitDetail.overallBathroomsUpdateStatusType));

	let haveData = false;
	cpu.forEach(puc => {
		let val = puc.propertyUnitDetail.overallBathroomsUpdateStatusType;
		if (val) {
			list.push(h.toEnumText(val));
			haveData = true;
		} else
			list.push("");
	});

	if (!haveData) return [];
	return list;
}

function GetQCInteriorConditionOverallFlooring(pu, cpu) {
	const list = [];

	list.push("  Overall Flooring");
	var val = pu.GetComponentCondition("Flooring");
	list.push(val);

	let haveData = false;
	cpu.forEach(puc => {
		var val = puc.GetComponentCondition("Flooring");
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("");

	});

	if (!haveData) return [];
	return list;
}

function GetQCInteriorConditionWallsAndCeiling(pu, cpu) {
	const list = [];

	list.push("  Walls and Ceiling");
	var val = pu.GetComponentCondition("WallsAndCeiling");
	list.push(val);

	let haveData = false;
	cpu.forEach(puc => {
		var val = puc.GetComponentCondition("WallsAndCeiling");
		if (val) {
			list.push(val);
			haveData = true;
		} else
			list.push("");

	});

	if (!haveData) return [];
	return list;
}

/*******************************************************************************/
// 
//  ADU Interior Quality and Condition
// 
/*******************************************************************************/

function GetQCADUInteriorLocationOfADU(pu, cpu) {
	let list = [];
	if (!global.ptr.valuationAnalysis.ADUsExist()) return list;
	if (!pu.propertyUnitDetail.accessoryDwellingUnitIndicator) return list;

	list.push("!Location of ADU");
	let loc = pu.GetADULocation();
	list.push("!"+loc);

	for (let cp of cpu) {
		loc = cp.GetADULocation();
		list.push("!"+loc);
	}

	return list;
}

function GetQCADUInteriorQuality(pu, cpu) {
	let list = [];
	list.push("!Quality")
	let val = pu.propertyUnitDetail.interiorQualityRatingCode;
	list.push(val);

	cpu.forEach(cp => {
		if (!pu) {
			list.push("");
		} else {
			val = pu.propertyUnitDetail.interiorQualityRatingCode;
			list.push(val);
		}
	});

	return list;
}

function GetQCADUInteriorQualityKitchen(pu, cpu) {
	let list = [];


	return list;
}

function GetQCADUInteriorQualityOverallBathrooms(pu, cpu) {
	let list = [];


	return list;
}

function GetQCADUInteriorQualityOverallFlooring(pu, cpu) {
	let list = [];


	return list;
}

function GetQCADUInteriorQualityWallsAndCeiling(pu, cpu) {
	let list = [];


	return list;
}

function GetQCADUInteriorCondition(pu, cpu) {
	let list = [];
	list.push("!Condition")
	let val = pu.propertyUnitDetail.interiorConditionRatingCode;
	list.push(val);

	cpu.forEach(cp => {
		if (!pu) {
			list.push("");
		} else {
			val = pu.propertyUnitDetail.interiorConditionRatingCode;
			list.push(val);
		}
	});

	return list;
}

function GetQCADUInteriorConditionKitchen(pu, cpu) {
	let list = [];


	return list;
}

function GetQCADUInteriorConditionOverallBathrooms(pu, cpu) {
	let list = [];


	return list;
}

function GetQCADUInteriorConditionOverallFlooring(pu, cpu) {
	let list = [];


	return list;
}

function GetQCADUInteriorConditionWallsAndCeiling(pu, cpu) {
	let list = [];


	return list;
}
	


/*******************************************************************************/
// 
//  Overall Quality and Condition
// 
/*******************************************************************************/


// Function to get overall quality ratings
function GetOverallQuality(subDetail, compList) {
	const list = [];
	list.push("!Quality");
	list.push(global.ptr.subDetail.overallQualityRatingCode);

	for (const cp of global.ptr.compList) {
		let row1 = [];
		row1.push(cp.propertyDetail.overallQualityRatingCode);
		row1.push(h.amountOrEmpty());
		list.push(row1);
	}
	return list;
}

// Function to get overall condition ratings
function GetOverallCondition(subDetail, compList) {
	const list = [];
	list.push("!Condition");

	list.push(global.ptr.subDetail.overallConditionRatingCode);
	for (const cp of global.ptr.compList) {
		let row1 = [];
		row1.push(cp.propertyDetail.overallConditionRatingCode);
		row1.push(h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount("OverallConditionRating")));
		list.push(row1);
	}
	return list;
}

/*******************************************************************************/
// 
//  PropertyAmenities
// 
/*******************************************************************************/

function GetPropertyAmenitiesOutdoorAccessories() {
	let list = GetPropertyAmenitiesRow("OutdoorAccessories");
	return list;
}

function GetPropertyAmenitiesOutdoorLiving() {
	let list = GetPropertyAmenitiesRow("OutdoorLiving");
	return list;
}

function GetPropertyAmenitiesWaterFeatures() {
	let list = GetPropertyAmenitiesRow("WaterFeatures");
	return list;
}

function GetPropertyAmenitiesWholeHome() {
	let list = GetPropertyAmenitiesRow("WholeHome");
	return list;
}

function GetPropertyAmenitiesMiscellaneous() {
	let list = GetPropertyAmenitiesRow("Miscellaneous");
	return list;
}

function GetPropertyAmenitiesRow(category) {
	let list = [];
	list.push(h.toEnumText(category));
	let al = global.ptr.subProp.propertyAmenity.GetAmenityList(category);
	list.push( al.length > 0 ? al : "");

	let haveData = false;
	for (let cp of global.ptr.compList) {
		let row1 = [];
		if (cp.propertyAmenity) {
			var amen = cp.propertyAmenity.GetAmenityList(category);
			var adj = h.amountOrEmpty(cp.comparable.GetComparableAdjustmentAmount(category  + "Amenity"));
			if (amen.length > 0) {
				row1.push(amen);
				row1.push(adj);
				haveData = true;
			} else if (adj) {
				row1.push("--");
				row1.push(adj);
				haveData = true;
			} else {
				row1.push("--");
				row1.push("");
			}
		} else {
			row1.push("--");
			row1.push("");
		}
		list.push(row1);
	}

	if (!haveData) return [];
	return list;
}

/*******************************************************************************/
// 
//  VehicleStorage
// 
/*******************************************************************************/

function GetVehicleStorage() {
	let list = [];

	list.push("Type | Spaces | Detail")
	list.push(global.ptr.subProp.carStorages.GetVehicleStorageDetails());
	for (let cp of global.ptr.compList) {
			list.push(cp.carStorages.GetVehicleStorageDetails());
	}

	return list;
}


/*******************************************************************************/
// 
//  Outbuilding
// 
/*******************************************************************************/

// this section is processed in the outbuildingFunctions.js file

/*******************************************************************************/
// 
//  Summary
// 
/*******************************************************************************/

function GetSalesSummaryListPrice() {
	let list = [];
	list.push("List Price");
	
	let amount = h.amountOrEmpty(global.ptr.subProp.GetListPrice());
	if (global.ptr.bListedWithinPreviousYear && amount) list.push(amount);
	else
			list.push("--");

	for (var cp of global.ptr.compList)	{
			list.push(h.amountOrEmpty(cp.GetListPrice()));
	}

	return list;
}

function GetSalesSummaryContractPrice() {
	return GetContractPrice();
}

function GetSalesSummarySalePrice(comps) {
	return GetSalePrice(comps);
}

function GetSalesSummaryNetAdjustmentTotal() {
	let list = [];
	list.push("Net Adjustment Total");

	list.push("GRAY");
	for (let cp of global.ptr.compList) {
		list.push(h.toDollarAmount(cp.comparable.GetTotalAdjustmentAmount()));
	}

	return list;
}

function GetSalesSummaryAdjustedPricePerUnit() {
	let list = [];
	if (!global.ptr.anyLivingUnitCountGTOne) return[];
	list.push("Adjusted Price Per Unit");
	list.push("GRAY");

	let haveData = false;
	for (let cp of global.ptr.compList) {
		let amount = h.amountOrEmpty(cp.comparable.comparableDetail.adjustedSalesPricePerUnitAmount);
		if (amount) haveData = true;
		list.push(amount);
	}
	if (!haveData) return [];

	return list;
}

function GetSalesSummaryAdjustedPricePerBedroom() {
	let list = [];
	if (!global.ptr.anyLivingUnitCountGTOne) return[];
	list.push("Adjusted Price Per Bedroom");

	list.push("GRAY");
	let bHasComps = false;
	for (let cp of global.ptr.compList) {
		let amount = cp.comparable.comparableDetail.adjustedSalesPricePerBedroomAmount;
		if (!amount.HasValue() || global.ptr.subLivingUnitCount <= 1)
				list.push("");
		else
		{
				list.push(amount.ToDollarAmount());
				bHasComps = true;
		}
	}
	if (!bHasComps) return [];

	return list;
}

function GetSalesSummaryPricePerGrossBuildingFinishedArea() {
	let list = [];
	if (global.ptr.subLivingUnitCount <= 1) return [];

	list.push("Price Per Gross Building\nFinished Area");
	list.push("GRAY");

	for (let cp of global.ptr.compList) {
		let price = h.amountOrEmpty(cp.comparable.comparableDetail.pricePerUnitOfMeasureTypeForTotalFinishedAreaOfAllLivingUnitsIncludingADU);
		list.push(price);
	}

	return list;
}

function GetSalesSummaryPricePerFinishedAreaAboveGrade() {
	let list = [];
	if (global.ptr.subLivingUnitCount !== 1) return [];
	let haveData = false;
	if (global.ptr.subProp.GetUnitStandardAboveGradeFinishedAreaMeasureExists()) haveData = true;

	list.push("Price Per Finished Area\nAbove Grade");
	list.push("GRAY");

	for (let cp of global.ptr.compList)
	{
		haveData |= cp.GetUnitStandardAboveGradeFinishedAreaMeasureExists();
		let price = h.amountOrEmpty(cp.comparable.comparableDetail.pricePerTotalStandardAboveGradeFinishedAreaAmount);
		if (!price) 
			list.push("");
		else {
			list.push(price);
			haveData = true;
		}
	}

	if (!haveData) return [];
	return list;
}

function GetSalesSummaryAdjustedPrice() {
	let list = [];
	list.push("Adjusted Price");
	list.push("GRAY");

	for (let cp of global.ptr.compList) {
		let price = h.amountOrEmpty(cp.comparable.comparableDetail.adjustedSalesPriceAmount);
		list.push(price);
		}

	return list;
}

export function GetSalesSummaryComparableWeight(comps) {
	let list = [];
	list.push("Comparable Weight");
	list.push("GRAY");

	for (let cp of comps) {
		let type = h.toEnumText(cp.comparable.comparableDetail.comparableWeightType);
		list.push(type);
		}
	return list;
}

export function GetSalesCompIndicatedValue() {
	let amount = global.ptr.valuationAnalysis.GetIndicatedValueBySalesComparisonApproach();
	return amount.ToDollarAmount();
}

/*******************************************************************************/
// 
//  
// 
/*******************************************************************************/


function GetComparableAdjustment(ca) {
  let list = [];
	list.push("");
    list.push(ca.additionalComparisonLineItemDescription);

    global.ptr.compList.forEach(cp => {
        const cpca = cp.GetComparableAdjustment(ca.comparableAdjustmentType, ca.additionalComparisonLineItemIdentifier);

        if (!cpca) {
            list.push(null);
            list.push(null);
        } else {
            list.push(cpca.additionalComparisonLineItemDescription);
            list.push(cpca.comparableAdjustmentAmount.ToDollarAmount());
        }
    });

    return list;
}

export function PropertiesAnalyzedNotUsedList() {
	let list = [];

	for ( let apnu of global.ptr.valuationAnalysis.analyzedProperties.analyzedPropertyList) {
		let row1 = [];
		row1.push(apnu.comparable.comparableDetail.propertyOrdinalNumber.toString());
		row1.push(apnu.address.GetFullAddress());

		let statusType = apnu.listingInformations[0].listingInformationDetail.listingStatusType;
		row1.push(h.toEnumText(statusType));

		if (statusType === "SettledSale")
			row1.push(apnu.sales.GetHistoryTransferDate().FormatMDY());
		else
			row1.push("");

		row1.push(apnu.propertyNotUsed.GetNotUsedReasons())
		row1.push(apnu.propertyNotUsed.propertyNotUsedDetail.additionalPropertyAnalyzedNotUsedText);
		list.push(row1);
	}

	return list;
}

